module.exports = __webpack_public_path__ + "static/img/wenwu.0d3c32a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cases/wenwu.png
// module id = kOwL
// module chunks = 1